import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import clsx from "clsx";

// Custom components
import CustomizedSwitches from "@/Layouts/components/InputComponents/CustomizedSwitches";
import InputValue from "@/Layouts/components/InputComponents/InputValue";

// MUI
import { Grid, Typography } from "@mui/material";

export default function CommissionCap(props) {
	const { value, enabled = false, readOnly = false, updateCapSwitch = () => {}, updateCapValue = () => {} } = props;

	const [checked, setChecked] = useState(false);

	useEffect(() => {
		setChecked(enabled);

		return () => {
			setChecked(false);
		};
	}, [enabled]);

	return (
		<Grid container alignItems="center">
			<Grid item xs={5}>
				<CustomizedSwitches
					disabled={readOnly}
					textRight
					textChecked="Enable Cap"
					textUnChecked="Enable Cap"
					onChange={(val) => {
						setChecked(val);
						updateCapSwitch?.(val);
					}}
					checked={checked}
				/>
			</Grid>
			<Grid item xs={1}>
				<Typography
					className={clsx({
						"cap-label": true,
						"!text-disabled": readOnly,
					})}
				>
					Cap
				</Typography>
			</Grid>
			<Grid item xs={3}>
				<InputValue
					readOnly={readOnly || !checked}
					value={value || 0}
					data={[
						{
							type: "Dollar",
							min: 0,
							max: 5000,
							decimals: 2,
							decimalsEditable: false,
							disabled: !checked,
						},
					]}
					sx={{ width: "95px" }}
					onActionUpdate={updateCapValue}
				/>
			</Grid>
		</Grid>
	);
}
CommissionCap.propTypes = {
	value: PropTypes.number,
	enabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	updateCapSwitch: PropTypes.func,
	updateCapValue: PropTypes.func,
};
